<template>
<div>
  <main-header-nav
    :goBack="goBack"
    :title="'造价模板列表'"
    :content="'新建造价模板'">
  </main-header-nav>
  <div
    v-loading="loading"
    style="width: 800px;margin: 0px auto;">
    <project-template-form
      :type="type"
      :rules="rules"
      :form="addForm"
      :checkedData="checkedData"
    >
    </project-template-form>
  </div>
</div>
</template>

<script>
import MainHeaderNav from '../common/MainHeaderNav'
import ProjectTemplateForm from './ProjectTemplateForm'
export default {
  name: 'AddProjectTemplate',
  components: {
    MainHeaderNav, ProjectTemplateForm
  },

  methods: {
    goBack () {
      this.$router.replace('/project_templates')
    }
  },

  data () {
    return {
      loading: false,
      type: 'add',
      rules: {
        name: [{ required: true, message: '模板名称不能为空', trigger: 'blur' }],
        date: [{ required: true, message: '时间不能为空', trigger: 'blur' }]
      },
      checkedData: {
        majorMaterialUsageCheckList: [],
        projectItemTreeData: [],
        majorMaterialUsageTreeData: []
      },
      addForm: {
        name: '',
        projectItems: '',
        majorMaterialsUsage: ''
      }
    }
  },

  mounted () {
    var self = this
    this.$data.loading = true
    this.getRequest('/major_materials_usage').then(resp => {
      if (resp && resp.result) {
        var majorMaterialsUsage = resp.result
        self.$data.checkedData.majorMaterialUsageTreeData = majorMaterialsUsage
        this.getRequest('/project_items')
          .then(resp => {
            if (resp && resp.result) {
              self.$data.loading = false
              self.$data.checkedData.projectItemTreeData = self.projectUtil.generateProjectItemTreeData(resp.result)
            }
          })
      }
    })
  }
}
</script>

<style scoped>

</style>
